import { render, staticRenderFns } from "./DialogDetailTeacherGroup.vue?vue&type=template&id=1cd587b0&scoped=true"
import script from "./DialogDetailTeacherGroup.vue?vue&type=script&lang=js"
export * from "./DialogDetailTeacherGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogDetailTeacherGroup.vue?vue&type=style&index=0&id=1cd587b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd587b0",
  null
  
)

export default component.exports